class ProductVariantImagesAsSwatches extends HTMLElement {
  constructor() {
    super();
    this.imageAsSwatchClass = ".image-as-swatch";
    this.productOverviewJSON = JSON.parse(
      document.querySelector("#pdp-product-overview-json").textContent
    );
  }
  /**
   * Called when the element is inserted into the DOM.
   */
  connectedCallback() {
    this.section = this;
    this.swatchTitle = this.section.querySelector("#selected-swatch-title");
    this.loadSection();

    this.section.addEventListener(
      "click",
      this.swatchClickEventHandler.bind(this)
    );
  }

  /**
   * Called when the element is removed from the DOM.
   * Removes event listeners to prevent memory leaks.
   */
  disconnectedCallback() {
    this.section.removeEventListener(
      "click",
      this.swatchClickEventHandler.bind(this),
      true
    );
  }

  /**
   * Event handler for swatch click events.
   * Updates the selected state, sets swatch title, and triggers product gallery filtering.
   * @param {Event} event - The click event.
   */
  swatchClickEventHandler(event) {
    const swatch = event.target.closest(`${this.imageAsSwatchClass}`);
    if (!swatch) return;
    this.removeSwatchSelectedState();
    this.setSwatchSelectedState(swatch);
    const { swatchHandle, swatchTitle, variantIsSoldOut } = swatch.dataset;

    const variant = this.productOverviewJSON.variants.find(
      (el) => el.title === swatchTitle
    );
    const price = variant.price / 100;

    this.setSwatchTitle(swatchTitle);
    Shopify?.ProductGalleryFilterByVariantHandle(swatchHandle);
    Shopify?.ProductOverviewSetAddToCartDisabledAttribute(variantIsSoldOut);
    Shopify?.ProductOverviewUpdateVariantPrice(price);
    Shopify?.ProductOverviewShowOutStockKlavyoButton(variantIsSoldOut);
  }

  /**
   * Loads the initial section by selecting the default swatch (if any).
   */
  loadSection() {
    const selectedSwatch = this.querySelector(
      `${this.imageAsSwatchClass}[data-swatch-selected="true"]`
    );
    const { swatchHandle, swatchTitle, variantIsSoldOut } =
      selectedSwatch.dataset;
    Shopify?.ProductGalleryFilterByVariantHandle(swatchHandle);
    Shopify?.ProductOverviewSetAddToCartDisabledAttribute(variantIsSoldOut);
    this.setSwatchTitle(swatchTitle);
    Shopify?.ProductOverviewShowOutStockKlavyoButton(variantIsSoldOut);
  }

  /**
   * Sets the title of the selected swatch.
   * @param {string} title - The title to be set.
   */
  setSwatchTitle(title) {
    this.swatchTitle.innerHTML = title;
  }

  /**
   * Sets the selected state of the given swatch element.
   * @param {HTMLElement} element - The swatch element.
   */
  setSwatchSelectedState(element) {
    element.dataset.swatchSelected = true;
  }

  /**
   * Removes the selected state from the currently selected swatch.
   */
  removeSwatchSelectedState() {
    const element = this.section.querySelector(
      `${this.imageAsSwatchClass}[data-swatch-selected="true"]`
    );
    element.dataset.swatchSelected = false;
  }
}
customElements.define(
  "product-variant-images-as-swatches-layout",
  ProductVariantImagesAsSwatches
);
